import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import SelectDropdown from "../../../ui/forms/SelectDropdown";
import { getLitigationClients } from "../../../API/litigationApis";
import { showToast } from "../../../utils/handleToast";

function LigationBatchFilter({ show, close, onApplyFilters, currentFilters = {} }) {
    const [filters, setFilters] = useState({
        client: "",
        batchName: "",
        ...currentFilters
    });
    const [clientOptions, setClientOptions] = useState([]);
    const [loadingClients, setLoadingClients] = useState(false);

    // Fetch clients when component mounts
    useEffect(() => {
        if (show) {
            fetchClients();
        }
    }, [show]);

    // Update local filters when currentFilters prop changes
    useEffect(() => {
        setFilters({
            client: "",
            batchName: "",
            ...currentFilters
        });
    }, [currentFilters]);

    const fetchClients = async () => {
        setLoadingClients(true);
        try {
            const response = await getLitigationClients();
            if (response?.data?.results) {
                const options = response.data.results.map((client) => ({
                    label: client.full_name,
                    value: client.name,
                }));
                setClientOptions(options);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
            showToast({ variant: "error", message: "Failed to fetch clients" });
        } finally {
            setLoadingClients(false);
        }
    };

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleApplyFilters = () => {
        // Remove empty filters
        const cleanedFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key] && filters[key].trim() !== "") {
                cleanedFilters[key] = filters[key];
            }
        });
        
        onApplyFilters(cleanedFilters);
        close();
    };

    const handleClearFilters = () => {
        const clearedFilters = {
            client: "",
            batchName: ""
        };
        setFilters(clearedFilters);
        onApplyFilters({});
        close();
    };

    const closeFilter = () => {
        close();
    };

    return (
        <Modal size="md" show={show} onHide={close} backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Filter Batches</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* Client Dropdown Filter */}
                    <Form.Group className="mb-3 mt-3">
                        <Form.Label>Client</Form.Label>
                        <SelectDropdown
                            options={[{ label: "All Clients", value: "" }, ...clientOptions]}
                            placeholder={loadingClients ? "Loading clients..." : "Select client"}
                            value={filters.client}
                            onChange={(val) => handleFilterChange("client", val)}
                            disabled={loadingClients}
                        />
                        {loadingClients && (
                            <Form.Text className="text-muted">
                                Loading clients...
                            </Form.Text>
                        )}
                    </Form.Group>

                    {/* Batch Name Text Filter */}
                    <Form.Group className="mb-3">
                        <Form.Label>Batch Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter batch name to search..."
                            value={filters.batchName}
                            onChange={(e) => handleFilterChange("batchName", e.target.value)}
                        />
                        <Form.Text className="text-muted">
                            Search by batch name or reference
                        </Form.Text>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={handleClearFilters}>
                    Clear All
                </Button>
                <Button variant="secondary" onClick={closeFilter}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleApplyFilters}>
                    Apply Filters
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default LigationBatchFilter;